import Axios from 'axios'
import * as R from 'ramda'

Axios.defaults.baseURL = 'http://api-beta.ceslyweb.com'

const credentials = sessionStorage.getItem('token')
if (credentials) {
  const data = JSON.parse(credentials)
  Axios.defaults.headers.common['Authorization'] = `${data.tokenType} ${data.accessToken}`
}
